export const TRAVELBASE_AFF = 'travelbase_aff';
export const TRAVELBASE_AFF_REFERENCE = 'travelbase_aff_reference';
